import { useCallback, useRef } from 'react';

import { useMetronomeStore } from './MetronomePlugin';
import useMetronomeEngine from '../../../../../hooks/useMetronomeEngine';

// A tap on a part tempo marker: stops the metronome if it is already at that tempo, otherwise retunes
// whichever one is playing, the way a song change does (see useSongChangeMetronome), or starts one.
// One engine for the whole page, since each engine keeps a worker of its own.
const usePartTempoMetronome = () => {
  const idRef = useRef(`metronome-part-tempo-${Math.random()}`);
  const { start } = useMetronomeEngine(idRef.current);

  return useCallback(
    (bpm, timeSignature = '4/4') => {
      if (!(bpm > 0)) return;

      const { activeWorkerRef, activeMetronomeId, activeBpm, setActiveBpm, stopAllMetronomes } =
        useMetronomeStore.getState();

      if (activeWorkerRef && activeMetronomeId) {
        if (Number(activeBpm) === bpm) {
          stopAllMetronomes();

          return;
        }

        activeWorkerRef.postMessage({ action: 'updateBPM', bpm, timeSignature });
        setActiveBpm(bpm);

        return;
      }

      start(bpm, timeSignature);
    },
    [start],
  );
};

export default usePartTempoMetronome;
